import supabase from '../supabase/supabase';

const SUPABASE_URL = 'https://mhqmasmmstwjxmjhbaza.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1ocW1hc21tc3R3anhtamhiYXphIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2NDM0OTUsImV4cCI6MjA4ODIxOTQ5NX0.UQaC2Di6iOxg_x4BeuDUPnWA9HCuNG_GLSj0XSLItc0';

const defaultReviews = [
  { id: 1, name: 'Sarah Jenkins', role: 'Verified Buyer', content: 'Absolutely love this product! It exceeded all my expectations and the quality is outstanding.', rating: 5, avatar_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' },
  { id: 2, name: 'Michael Chen', role: 'Entrepreneur', content: 'This completely transformed how I run my business. Highly recommended to anyone on the fence.', rating: 5, avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' },
  { id: 3, name: 'Emily Rodriguez', role: 'Designer', content: 'Incredible attention to detail and superb customer service. I will definitely be a returning customer.', rating: 4, avatar_url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' }
];

// Browser-safe base64 encoding
function toBase64(str) {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(str).toString('base64');
  }
  return btoa(unescape(encodeURIComponent(str)));
}

export async function generateHtml(page, globalData, projectId) {
  const { droppedElements = [], headerPadding, canvasPadding } = page.content || {};
  const { logoData, menuItems, menuStyles, footerData } = globalData || {};

  let faviconUrl = '';
  let shareImageUrl = '';
  let whatsappWidget = { enabled: false, number: '' };

  if (projectId) {
    try {
      const { data: websiteData } = await supabase
        .from('websites_1772750000000')
        .select('favicon_url, share_image_url, layout_data')
        .eq('id', projectId)
        .single();
      if (websiteData) {
        faviconUrl = websiteData.favicon_url || '';
        shareImageUrl = websiteData.share_image_url || '';
        if (websiteData.layout_data?.whatsappWidget) {
          whatsappWidget = websiteData.layout_data.whatsappWidget;
        }
      }
    } catch (err) {
      console.warn('Could not fetch favicon/share image:', err);
    }
  }

  const checkType = (elements, type) => {
    for (const el of elements) {
      if (el.type === type) return true;
      if (el.type === 'container' && el.columns) {
        for (const col of el.columns) {
          if (checkType(col, type)) return true;
        }
      }
    }
    return false;
  };

  let storeProducts = [];
  if (projectId && checkType(droppedElements, 'products')) {
    const { data } = await supabase
      .from('store_products_1772955957776')
      .select('*')
      .eq('project_id', projectId)
      .eq('is_active', true);
    storeProducts = data || [];
  }

  let siteReviews = [];
  if (projectId && checkType(droppedElements, 'reviews')) {
    try {
      const { data } = await supabase
        .from('reviews_1775200000000')
        .select('*')
        .eq('project_id', projectId)
        .order('order', { ascending: true });
      siteReviews = data || [];
    } catch (err) {
      console.warn('Could not fetch reviews:', err);
    }
  }

  const productRegistry = [];
  const getProductIndex = (p) => {
    const existing = productRegistry.findIndex(r => r.id === p.id);
    if (existing !== -1) return existing;
    productRegistry.push({
      id: p.id,
      name: p.name,
      price: p.price,
      compare_at_price: p.compare_at_price,
      image_url: p.image_url,
      images: p.images || [],
      description: p.description,
      category: p.category,
      stock: p.stock,
      on_sale: p.on_sale,
      badge: p.badge || null,
    });
    return productRegistry.length - 1;
  };

  function renderStyles(styles, type) {
    if (!styles) return '';
    let css = '';
    for (const [k, v] of Object.entries(styles)) {
      if (k === 'fontSize') {
        if (type === 'heading') {
          css += `font-size: clamp(${Math.max(24, v * 0.4)}px, 6vw, ${v}px); `;
        } else {
          css += `font-size: clamp(${Math.max(14, v * 0.7)}px, 2.5vw, ${v}px); `;
        }
      } else if (k === 'lineHeight') css += `line-height: ${v}; `;
      else if (k === 'fontWeight') css += `font-weight: ${v}; `;
      else if (k === 'textAlign') css += `text-align: ${v}; `;
      else if (k === 'color') css += `color: ${v}; `;
      else if (k === 'marginTop') css += `margin-top: ${v}px; `;
      else if (k === 'marginBottom') css += `margin-bottom: ${v}px; `;
    }
    return css;
  }

  function renderWidget(el) {
    if (el.type === 'heading') {
      return `<h2 class="widget-heading" style="${renderStyles(el.styles, 'heading')}">${el.content || ''}</h2>`;
    }

    if (el.type === 'text') {
      return `<div class="widget-text" style="${renderStyles(el.styles, 'text')}">${el.content || ''}</div>`;
    }

    if (el.type === 'button') {
      const s = el.styles || {};
      const target = s.linkType === 'anchor' && s.link && !s.link.startsWith('#')
        ? `#${s.link}`
        : (s.link || '#');
      return `
        <div class="widget-button-wrapper">
          <a href="${target}" class="widget-button" style="background-color:${s.bgColor || '#000'};color:${s.textColor || '#fff'};border-radius:${s.borderRadius || 8}px;">
            ${s.text || 'Button'}
          </a>
        </div>`;
    }

    if (el.type === 'image') {
      const s = el.styles || {};
      return `<img src="${s.imageUrl || ''}" alt="${s.altText || 'Image'}" class="widget-image" style="border-radius:8px;object-fit:${s.objectFit || 'cover'};" />`;
    }

    if (el.type === 'spacer') {
      return `<div style="height:${el.styles?.height || 50}px;width:100%;"></div>`;
    }

    if (el.type === 'container') {
      const s = el.styles || {};
      const bg = s.backgroundType === 'image' && s.backgroundImage
        ? `background-image:url('${s.backgroundImage}');background-size:${s.backgroundSize || 'cover'};background-position:center;`
        : `background-color:${s.backgroundColor || '#fff'};`;
      const colsHtml = el.columns.map(col => `
        <div class="col">
          ${col.map(w => renderWidget(w)).join('\n')}
        </div>`).join('\n');
      return `
        <section id="${s.anchorId || ''}" class="section-container" style="${bg}padding-top:${s.paddingTop || 48}px;padding-bottom:${s.paddingBottom || 48}px;">
          ${s.overlayOpacity > 0 ? `<div class="section-overlay" style="background-color:${s.overlayColor || '#000'};opacity:${s.overlayOpacity};"></div>` : ''}
          <div class="container relative z-10">
            <div class="row">${colsHtml}</div>
          </div>
        </section>`;
    }

    if (el.type === 'contact-form') {
      const s = el.styles || {};
      return `
        <div class="contact-form-wrapper" style="background:${s.formBgColor || '#fff'};border-radius:${s.borderRadius || 12}px;">
          <form action="mailto:${s.destinationEmail || ''}" method="POST" enctype="text/plain" class="contact-form">
            <div class="form-row">
              <input type="text" placeholder="First Name" required style="background:${s.inputBgColor || '#f9fafb'};border-radius:${Math.max(0, s.borderRadius - 4)}px;color:${s.textColor || '#111'};" />
              <input type="text" placeholder="Last Name" required style="background:${s.inputBgColor || '#f9fafb'};border-radius:${Math.max(0, s.borderRadius - 4)}px;color:${s.textColor || '#111'};" />
            </div>
            <input type="email" placeholder="Email Address" required style="background:${s.inputBgColor || '#f9fafb'};border-radius:${Math.max(0, s.borderRadius - 4)}px;color:${s.textColor || '#111'};" />
            <textarea placeholder="Message" rows="4" required style="background:${s.inputBgColor || '#f9fafb'};border-radius:${Math.max(0, s.borderRadius - 4)}px;color:${s.textColor || '#111'};"></textarea>
            <button type="submit" class="form-submit-btn" style="background:${s.buttonBgColor || '#2dd4bf'};color:${s.buttonTextColor || '#fff'};border-radius:${Math.max(0, s.borderRadius - 2)}px;">
              ${s.buttonText || 'Send Message'}
            </button>
          </form>
        </div>`;
    }

    if (el.type === 'reviews') {
      const s = el.styles || {};
      const limit = s.limit || 10;
      const columns = s.columns || 3;
      const showAvatars = s.showAvatars !== false;
      const showSummary = s.showSummary !== false;
      const fullWidth = s.fullWidth || false;
      const cardBgColor = s.cardBgColor || '#ffffff';
      const textColor = s.textColor || '#111827';
      const starColor = s.starColor || '#f59e0b';
      const borderRadius = s.borderRadius || 16;
      
      let widgetReviews = siteReviews.length > 0 ? siteReviews : (s.reviews || defaultReviews);
      widgetReviews = widgetReviews.slice(0, limit);

      if (widgetReviews.length === 0) {
         return ''; 
      }

      const avgRating = widgetReviews.reduce((acc, r) => acc + r.rating, 0) / widgetReviews.length;

      const starSvg = (filled, color) => `<svg width="16" height="16" viewBox="0 0 24 24" fill="${filled ? color : 'none'}" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="${filled ? '' : 'opacity-30'}"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;
      const bigStarSvg = (filled, color) => `<svg width="24" height="24" viewBox="0 0 24 24" fill="${filled ? color : 'none'}" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="${filled ? '' : 'opacity-30'}"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;

      let summaryHtml = '';
      if (showSummary) {
        let stars = '';
        for(let i=1; i<=5; i++) stars += bigStarSvg(i <= Math.round(avgRating), starColor);
        summaryHtml = `
          <div class="reviews-summary" style="color: ${textColor}">
            <div class="reviews-summary-stars">${stars}</div>
            <div class="reviews-summary-score">${avgRating.toFixed(1)} out of 5</div>
            <div class="reviews-summary-count">Based on ${widgetReviews.length} reviews</div>
          </div>
        `;
      }

      let cardsHtml = widgetReviews.map(r => {
        let stars = '';
        for(let i=1; i<=5; i++) stars += starSvg(i <= r.rating, starColor);
        
        let avatarHtml = '';
        if (showAvatars && r.avatar_url) {
          avatarHtml = `<img src="${r.avatar_url}" alt="${r.name}" class="review-avatar" />`;
        }

        return `
          <div class="review-card" style="background-color: ${cardBgColor}; border-radius: ${borderRadius}px; color: ${textColor};">
            <div class="review-stars">${stars}</div>
            <p class="review-content">"${r.content}"</p>
            <div class="review-author">
              ${avatarHtml}
              <div class="review-author-info">
                <div class="review-author-name">${r.name}</div>
                ${r.role ? `<div class="review-author-role">${r.role}</div>` : ''}
              </div>
            </div>
          </div>
        `;
      }).join('');

      const widthClass = fullWidth ? 'reviews-full-width' : 'reviews-contained';

      return `
        <div class="reviews-widget-wrapper ${widthClass}">
          ${summaryHtml}
          <div class="reviews-grid reviews-grid-${columns}">
            ${cardsHtml}
          </div>
        </div>
      `;
    }

    if (el.type === 'products') {
      const s = el.styles || {};
      const limit = s.limit || 6;
      const cat = s.productCategory || '';
      const columns = s.columns || 3;
      const mobileColumns = s.mobileColumns || 1;
      const showSaleBadge = s.showSaleBadge !== false;
      const fullWidth = s.fullWidth || false;

      let filtered = storeProducts;
      if (cat) filtered = filtered.filter(p => (p.category || '').includes(cat));
      filtered = filtered.slice(0, limit);

      if (filtered.length === 0) {
        return `<div class="empty-products">No products found in this category.</div>`;
      }

      const cards = filtered.map(p => {
        const idx = getProductIndex(p);
        const isOnSale = showSaleBadge && !p.badge && (p.on_sale || (p.compare_at_price > p.price));
        const discountPct = isOnSale && p.compare_at_price > p.price
          ? Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100)
          : null;

        const coverImg = (Array.isArray(p.images) && p.images.length > 0)
          ? p.images[0]
          : (p.image_url || '');

        return `
        <div class="product-card" data-product-index="${idx}">
          <div class="product-image-wrapper">
            ${coverImg
              ? `<img src="${coverImg}" alt="${p.name}" class="product-image" loading="lazy" />`
              : `<div class="product-image-placeholder"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg></div>`
            }
            ${p.badge
              ? `<div class="custom-badge" style="background:${getBadgeBg(p.badge)};color:${getBadgeText(p.badge)};">${p.badge}</div>`
              : isOnSale
                ? `<div class="sale-badge">${discountPct ? discountPct + '% OFF' : 'SALE'}</div>`
                : ''}
          </div>
          <div class="product-info">
            ${p.category ? `<div class="product-category">${p.category.split(',')[0]}</div>` : ''}
            <h3 class="product-title">${p.name}</h3>
            <div class="product-pricing">
              <span class="product-price">R${Number(p.price).toFixed(2)}</span>
              ${p.compare_at_price > p.price ? `<span class="product-compare-price">R${Number(p.compare_at_price).toFixed(2)}</span>` : ''}
            </div>
            <div class="product-stock-row">
              <span class="product-stock-dot" style="background:${p.stock > 0 ? '#22c55e' : '#ef4444'};"></span>
              <span class="product-stock-label" style="color:${p.stock > 0 ? '#374151' : '#ef4444'};">${p.stock > 0 ? `${p.stock} in stock` : 'Out of stock'}</span>
            </div>
            <button
              class="add-to-cart-btn"
              data-product-index="${idx}"
              ${p.stock <= 0 ? 'disabled' : ''}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              ${p.stock > 0 ? 'Add to Cart' : 'Out of Stock'}
            </button>
          </div>
        </div>`;
      }).join('');

      const gridClass = `products-grid-${columns}-${mobileColumns}`;
      const widthClass = fullWidth ? 'products-full-width' : 'products-contained';
      return `<div class="products-widget-wrapper ${widthClass}"><div class="${gridClass}">${cards}</div></div>`;
    }

    return '';
  }

  function getBadgeBg(badge) {
    const map = {
      'New': '#3b82f6', 'Hot': '#ef4444', 'Sale': '#f59e0b',
      'Limited': '#8b5cf6', 'Sold Out': '#6b7280', 'Best Seller': '#10b981',
      'Featured': '#ec4899', 'Clearance': '#f97316',
    };
    return map[badge] || '#111827';
  }
  function getBadgeText(badge) {
    const map = {
      'New': '#ffffff', 'Hot': '#ffffff', 'Sale': '#000000',
      'Limited': '#ffffff', 'Sold Out': '#ffffff', 'Best Seller': '#ffffff',
      'Featured': '#ffffff', 'Clearance': '#ffffff',
    };
    return map[badge] || '#ffffff';
  }

  const bodyHtml = droppedElements.map(el => renderWidget(el)).join('\n');

  const productGridConfigs = new Set();
  const collectGridConfigs = (elements) => {
    for (const el of elements) {
      if (el.type === 'products') {
        const s = el.styles || {};
        productGridConfigs.add(`${s.columns || 3}-${s.mobileColumns || 1}`);
      }
      if (el.type === 'container' && el.columns) {
        for (const col of el.columns) collectGridConfigs(col);
      }
    }
  };
  collectGridConfigs(droppedElements);

  let dynamicGridCSS = '';
  productGridConfigs.forEach(config => {
    const [desktop, mobile] = config.split('-').map(Number);
    dynamicGridCSS += `
    .products-grid-${config}{display:grid;grid-template-columns:repeat(${mobile},1fr);gap:32px;width:100%;}
    @media(min-width:768px){.products-grid-${config}{grid-template-columns:repeat(2,1fr);}}
    @media(min-width:1024px){.products-grid-${config}{grid-template-columns:repeat(${desktop},1fr);}}
    `;
  });

  const footer = {
    companyName: footerData?.companyName || 'BRAND LOGO',
    tagline: footerData?.tagline || 'Building amazing experiences for everyone.',
    copyright: footerData?.copyright || '© 2025 Your Company. All rights reserved.',
    backgroundColor: footerData?.backgroundColor || '#111827',
    textColor: footerData?.textColor || '#9ca3af',
    accentColor: footerData?.accentColor || '#2dd4bf',
    headingColor: footerData?.headingColor || '#ffffff',
    quickLinksTitle: footerData?.quickLinksTitle || 'Quick Links',
    contactTitle: footerData?.contactTitle || 'Get In Touch',
    contactDescription: footerData?.contactDescription || "Have questions? We'd love to hear from you.",
    contactButtonText: footerData?.contactButtonText || 'Contact Us',
    contactButtonBg: footerData?.contactButtonBg || '#2dd4bf',
    contactButtonTextColor: footerData?.contactButtonTextColor || '#ffffff',
    footerBottomText: footerData?.footerBottomText || 'Built with',
    links: footerData?.links || [
      { label: 'Home', href: '/' },
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
  };

  const pageTitle = page.name || logoData?.content || 'My Website';
  const metaDescription = `${pageTitle} - Built with SideHustlr`;

  const storeScript = `
(function() {
  'use strict';
  
  const PRODUCTS = window.__STORE_PRODUCTS__ || [];
  const SUPABASE_URL = window.__SUPABASE_URL__;
  const SUPABASE_KEY = window.__SUPABASE_KEY__;
  const PROJECT_ID = window.__PROJECT_ID__;

  let cart = [];
  try { cart = JSON.parse(localStorage.getItem('store_cart') || '[]'); } catch(e) { cart = []; }
  
  let currentModalProduct = null;
  let currentImageIndex = 0;
  let currentCheckoutStep = 1;
  let checkoutForm = { name: '', email: '', phone: '', address: '', city: '', zipCode: '', country: 'South Africa', state: '', company: '' };
  let enabledProviders = [];
  let selectedProvider = null;
  let isLoadingProviders = false;

  const PAYMENT_PROVIDERS = [
    { id: 'payfast', name: 'PayFast', description: 'Pay securely with card, EFT and more.', icon: '💳', logoUrl: 'https://media-manager-c.questera.ai/greta-media/905f91485ab63acb0ca3d0eb7a8d12edb0e5fd8263e0c7ad4c0bd7710abc0b3f680db9e50b9a6deeaa0ab59826a97d73/images/aW1hZ2UvaGVpYw==/453cbc47ca9eeb25ae71e4daf3d6556c.heic' }
  ];

  function init() {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.add-to-cart-btn')) return;
        const idx = parseInt(this.getAttribute('data-product-index'), 10);
        if (!isNaN(idx) && PRODUCTS[idx]) openProductModal(PRODUCTS[idx]);
      });
    });

    document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const idx = parseInt(this.getAttribute('data-product-index'), 10);
        if (!isNaN(idx) && PRODUCTS[idx]) addProductToCart(PRODUCTS[idx]);
      });
    });

    document.getElementById('cart-toggle-btn').addEventListener('click', () => toggleCart());
    document.getElementById('cart-overlay').addEventListener('click', () => toggleCart(false));
    document.getElementById('close-cart-btn').addEventListener('click', () => toggleCart(false));
    document.getElementById('mobile-menu-toggle').addEventListener('click', () => {
      document.getElementById('mobile-nav').classList.toggle('open');
    });
    document.getElementById('checkout-btn-open').addEventListener('click', openCheckout);
    document.getElementById('close-checkout-btn').addEventListener('click', closeCheckout);
    document.getElementById('checkout-form').addEventListener('submit', handleCheckoutSubmit);
    document.getElementById('modal-close-btn').addEventListener('click', closeProductModal);
    document.getElementById('modal-add-to-cart').addEventListener('click', addToCartFromModal);
    document.getElementById('modal-prev-btn').addEventListener('click', prevImage);
    document.getElementById('modal-next-btn').addEventListener('click', nextImage);
    document.getElementById('product-modal').addEventListener('click', function(e) {
      if (e.target === this) closeProductModal();
    });

    document.querySelectorAll('.checkout-input').forEach(input => {
      input.addEventListener('input', function() {
        checkoutForm[this.getAttribute('data-field')] = this.value;
      });
    });

    renderCart();
    initPaymentCallback();
  }

  function addProductToCart(product) {
    if (!product) return;
    const existing = cart.find(item => item.id === product.id);
    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image_url: (Array.isArray(product.images) && product.images.length > 0) ? product.images[0] : (product.image_url || ''),
        quantity: 1
      });
    }
    saveCart();
    toggleCart(true);
  }

  function saveCart() {
    localStorage.setItem('store_cart', JSON.stringify(cart));
    renderCart();
  }

  function updateQuantity(id, delta) {
    cart = cart.map(item => {
      if (item.id === id) {
        const newQ = item.quantity + delta;
        return newQ > 0 ? {...item, quantity: newQ} : item;
      }
      return item;
    }).filter(item => item.quantity > 0);
    saveCart();
  }

  function removeFromCart(id) {
    cart = cart.filter(item => item.id !== id);
    saveCart();
  }

  function toggleCart(forceOpen) {
    const sidebar = document.getElementById('cart-sidebar');
    const overlay = document.getElementById('cart-overlay');
    const isOpen = sidebar.classList.contains('open');
    if (forceOpen === true || !isOpen) {
      sidebar.classList.add('open');
      overlay.classList.add('open');
    } else {
      sidebar.classList.remove('open');
      overlay.classList.remove('open');
    }
  }

  function renderCart() {
    const itemsContainer = document.getElementById('cart-items');
    const footer = document.getElementById('cart-footer');
    const badge = document.getElementById('cart-badge');
    const totalEl = document.getElementById('cart-total');
    let total = 0, count = 0;

    if (cart.length === 0) {
      itemsContainer.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
      footer.style.display = 'none';
      badge.style.display = 'none';
      return;
    }

    badge.style.display = 'flex';
    footer.style.display = 'block';
    
    itemsContainer.innerHTML = cart.map(item => {
      total += item.price * item.quantity;
      count += item.quantity;
      return \`<div class="cart-item">
        <img src="\${item.image_url || 'https://via.placeholder.com/100'}" class="cart-item-img" />
        <div class="cart-item-details">
          <h4 class="cart-item-title">\${item.name}</h4>
          <div class="cart-item-price">R\${Number(item.price).toFixed(2)}</div>
          <div class="cart-item-actions">
            <div class="qty-controls">
              <button class="qty-btn" onclick="updateQuantity('\${item.id}', -1)">-</button>
              <span class="qty-val">\${item.quantity}</span>
              <button class="qty-btn" onclick="updateQuantity('\${item.id}', 1)">+</button>
            </div>
            <button class="remove-btn" onclick="removeFromCart('\${item.id}')">Remove</button>
          </div>
        </div>
      </div>\`;
    }).join('');

    totalEl.textContent = 'R' + total.toFixed(2);
    badge.textContent = count;
  }

  function openProductModal(product) {
    if (!product) return;
    currentModalProduct = product;
    currentImageIndex = 0;

    const images = (Array.isArray(product.images) && product.images.length > 0)
      ? product.images
      : (product.image_url ? [product.image_url] : []);

    const mainImg = document.getElementById('modal-product-image');
    if (images.length > 0) {
      mainImg.src = images[0];
      mainImg.style.display = 'block';
    } else {
      mainImg.style.display = 'none';
    }

    const thumbsContainer = document.getElementById('modal-thumbnails');
    if (images.length > 1) {
      thumbsContainer.style.display = 'flex';
      thumbsContainer.innerHTML = images.map((url, idx) =>
        \`<button class="modal-thumb \${idx === 0 ? 'active' : ''}" data-idx="\${idx}" onclick="setModalImage(\${idx})">
          <img src="\${url}" alt="" />
        </button>\`
      ).join('');
    } else {
      thumbsContainer.style.display = 'none';
      thumbsContainer.innerHTML = '';
    }

    document.getElementById('modal-prev-btn').style.display = images.length > 1 ? 'flex' : 'none';
    document.getElementById('modal-next-btn').style.display = images.length > 1 ? 'flex' : 'none';

    const category = document.getElementById('modal-product-category');
    if (product.category) {
      category.textContent = product.category.split(',')[0];
      category.style.display = 'block';
    } else {
      category.style.display = 'none';
    }

    document.getElementById('modal-product-title').textContent = product.name;
    document.getElementById('modal-product-price').textContent = 'R' + Number(product.price).toFixed(2);
    
    const comparePrice = document.getElementById('modal-product-compare-price');
    if (product.compare_at_price && product.compare_at_price > product.price) {
      comparePrice.textContent = 'R' + Number(product.compare_at_price).toFixed(2);
      comparePrice.style.display = 'inline';
    } else {
      comparePrice.style.display = 'none';
    }

    document.getElementById('modal-product-description').innerHTML = product.description || 'No description available.';

    const stockDot = document.getElementById('modal-stock-dot');
    const stockLabel = document.getElementById('modal-stock-label');
    if (product.stock > 0) {
      stockDot.style.background = '#22c55e';
      stockLabel.textContent = product.stock + ' in stock';
      stockLabel.style.color = '#374151';
    } else {
      stockDot.style.background = '#ef4444';
      stockLabel.textContent = 'Out of stock';
      stockLabel.style.color = '#ef4444';
    }

    const addBtn = document.getElementById('modal-add-to-cart');
    if (product.stock <= 0) {
      addBtn.disabled = true;
      addBtn.classList.add('disabled');
      addBtn.innerHTML = '<span>Out of Stock</span>';
    } else {
      addBtn.disabled = false;
      addBtn.classList.remove('disabled');
      addBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg><span>Add to Cart</span>';
    }

    document.getElementById('product-modal').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function setModalImage(idx) {
    if (!currentModalProduct) return;
    const images = (Array.isArray(currentModalProduct.images) && currentModalProduct.images.length > 0)
      ? currentModalProduct.images : (currentModalProduct.image_url ? [currentModalProduct.image_url] : []);
    currentImageIndex = idx;
    document.getElementById('modal-product-image').src = images[idx];
    document.querySelectorAll('.modal-thumb').forEach((btn, i) => {
      btn.classList.toggle('active', i === idx);
    });
  }

  function closeProductModal() {
    document.getElementById('product-modal').classList.remove('open');
    document.body.style.overflow = '';
    currentModalProduct = null;
  }

  function addToCartFromModal() {
    if (currentModalProduct) {
      addProductToCart(currentModalProduct);
      closeProductModal();
    }
  }

  function prevImage() {
    if (!currentModalProduct) return;
    const images = (Array.isArray(currentModalProduct.images) && currentModalProduct.images.length > 0)
      ? currentModalProduct.images : (currentModalProduct.image_url ? [currentModalProduct.image_url] : []);
    if (images.length <= 1) return;
    currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
    setModalImage(currentImageIndex);
  }

  function nextImage() {
    if (!currentModalProduct) return;
    const images = (Array.isArray(currentModalProduct.images) && currentModalProduct.images.length > 0)
      ? currentModalProduct.images : (currentModalProduct.image_url ? [currentModalProduct.image_url] : []);
    if (images.length <= 1) return;
    currentImageIndex = (currentImageIndex + 1) % images.length;
    setModalImage(currentImageIndex);
  }

  async function fetchPaymentProviders() {
    if (!PROJECT_ID) return;
    isLoadingProviders = true;
    renderCheckoutStep();
    try {
      const keys = PAYMENT_PROVIDERS.map(p => 'payment_' + p.id);
      const res = await fetch(SUPABASE_URL + '/rest/v1/store_settings_1773100000000?project_id=eq.' + PROJECT_ID + '&key=in.(' + keys.join(',') + ')', {
        headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY }
      });
      const data = await res.json();
      const active = [];
      if (data && data.length > 0) {
        const settingsMap = {};
        data.forEach(row => { settingsMap[row.key] = row.value; });
        PAYMENT_PROVIDERS.forEach(provider => {
          const setting = settingsMap['payment_' + provider.id];
          if (!setting) return;
          const isEnabled = setting.enabled === true;
          const creds = setting.credentials || {};
          const hasCred = Object.values(creds).some(v => v !== null && v !== undefined && String(v).trim() !== '');
          if (isEnabled || hasCred) { provider.settings = setting; active.push(provider); }
        });
      }
      enabledProviders = active;
      if (active.length > 0) selectedProvider = active[0].id;
    } catch(e) { console.error('Failed fetching providers', e); }
    finally { isLoadingProviders = false; renderCheckoutStep(); }
  }

  function selectProvider(id) { selectedProvider = id; renderCheckoutStep(); }
  
  function openCheckout() { 
    toggleCart(false); 
    currentCheckoutStep = 1;
    checkoutForm = { name: '', email: '', phone: '', address: '', city: '', zipCode: '', country: 'South Africa', state: '', company: '' };
    document.getElementById('checkout-modal').classList.add('open'); 
    renderCheckoutStep();
    if (enabledProviders.length === 0 && !isLoadingProviders) fetchPaymentProviders(); 
  }
  
  function closeCheckout() { 
    document.getElementById('checkout-modal').classList.remove('open'); 
    currentCheckoutStep = 1;
  }

  function renderCheckoutStep() {
    const step1 = document.getElementById('checkout-step-1');
    const step2 = document.getElementById('checkout-step-2');
    const backBtn = document.getElementById('checkout-back-btn');
    const submitBtn = document.getElementById('checkout-submit-btn');
    
    if (currentCheckoutStep === 1) {
      step1.style.display = 'block';
      step2.style.display = 'none';
      backBtn.style.display = 'none';
      submitBtn.textContent = 'Continue to Payment';
    } else {
      step1.style.display = 'none';
      step2.style.display = 'block';
      backBtn.style.display = 'block';
      const curP = enabledProviders.find(x => x.id === selectedProvider);
      submitBtn.textContent = curP ? 'Pay with ' + curP.name : 'Complete Order';
      renderPaymentProviders();
    }
  }

  function renderPaymentProviders() {
    const container = document.getElementById('payment-providers-container');
    if (!container) return;
    if (isLoadingProviders) {
      container.innerHTML = '<div style="font-size:14px;color:#6b7280;text-align:center;padding:20px;">Loading payment securely...</div>';
      return;
    }
    if (enabledProviders.length === 0) {
      container.innerHTML = '<div style="padding:12px;background:#fef3c7;border:1px solid #fbbf24;border-radius:8px;font-size:14px;color:#b45309;"><strong>No payment methods configured</strong><div style="font-size:12px;margin-top:4px;">Enable a payment provider in the dashboard.</div></div>';
      document.getElementById('checkout-submit-btn').disabled = true;
      return;
    }
    container.innerHTML = enabledProviders.map(p => {
      const isSel = selectedProvider === p.id;
      const iconHtml = p.logoUrl
        ? \`<img src="\${p.logoUrl}" style="width:100%;height:100%;object-fit:contain;" alt="\${p.name}">\`
        : \`<span style="font-size:20px;">\${p.icon}</span>\`;
      return \`<button type="button" onclick="selectProvider('\${p.id}')" class="payment-method-card \${isSel ? 'selected' : ''}">
        <div class="payment-icon">\${iconHtml}</div>
        <div class="payment-info">
          <div class="payment-name">\${p.name}</div>
          <div class="payment-desc">\${p.description}</div>
        </div>
        <div class="payment-radio">\${isSel ? '<div class="payment-radio-dot"></div>' : ''}</div>
      </button>\`;
    }).join('');
    document.getElementById('checkout-submit-btn').disabled = !selectedProvider;
  }

  function handleCheckoutSubmit(e) {
    e.preventDefault();
    if (currentCheckoutStep === 1) {
      if (!checkoutForm.name || !checkoutForm.email || !checkoutForm.phone || !checkoutForm.address || !checkoutForm.city || !checkoutForm.zipCode) {
        document.getElementById('checkout-error').textContent = 'Please fill in all required fields.';
        document.getElementById('checkout-error').style.display = 'block';
        return;
      }
      document.getElementById('checkout-error').style.display = 'none';
      currentCheckoutStep = 2;
      renderCheckoutStep();
    } else {
      submitOrder();
    }
  }

  async function submitOrder() {
    if (cart.length === 0) return;
    if (enabledProviders.length > 0 && !selectedProvider) {
      document.getElementById('checkout-error').textContent = 'Please select a payment method.';
      document.getElementById('checkout-error').style.display = 'block';
      return;
    }
    const total = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    document.getElementById('checkout-error').style.display = 'none';
    document.getElementById('checkout-submit-btn').style.display = 'none';
    document.getElementById('checkout-spinner').style.display = 'block';

    try {
      const customerRes = await fetch(SUPABASE_URL + '/rest/v1/store_customers_1776316637000?select=id', {
        method: 'POST',
        headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY, 'Content-Type': 'application/json', 'Prefer': 'return=representation' },
        body: JSON.stringify({
          project_id: PROJECT_ID,
          full_name: checkoutForm.name,
          email: checkoutForm.email,
          phone: checkoutForm.phone,
          address: checkoutForm.address,
          city: checkoutForm.city,
          zip_code: checkoutForm.zipCode,
          country: checkoutForm.country,
          state: checkoutForm.state,
          company_name: checkoutForm.company
        })
      });
      const customerData = await customerRes.json();
      const customerId = customerData[0]?.id;

      const orderRes = await fetch(SUPABASE_URL + '/rest/v1/store_orders_1772955957776?select=id,order_number', {
        method: 'POST',
        headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY, 'Content-Type': 'application/json', 'Prefer': 'return=representation' },
        body: JSON.stringify({ 
          customer_id: customerId,
          customer_name: checkoutForm.name, 
          customer_email: checkoutForm.email,
          customer_phone: checkoutForm.phone,
          billing_address: checkoutForm.address,
          billing_city: checkoutForm.city,
          billing_zip: checkoutForm.zipCode,
          billing_country: checkoutForm.country,
          billing_state: checkoutForm.state,
          billing_company: checkoutForm.company,
          total: total, 
          status: 'pending', 
          payment_method: selectedProvider || 'payfast', 
          payment_status: 'pending', 
          project_id: PROJECT_ID || null 
        })
      });
      if (!orderRes.ok) throw new Error('Failed to create order');
      const orderData = await orderRes.json();
      const order = orderData[0];

      const itemsPayload = cart.map(item => ({ order_id: order.id, product_id: item.id, quantity: item.quantity, price: item.price }));
      await fetch(SUPABASE_URL + '/rest/v1/store_order_items_1772955957776', {
        method: 'POST',
        headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify(itemsPayload)
      });

      if (selectedProvider === 'payfast') {
        const pfProvider = enabledProviders.find(p => p.id === 'payfast');
        const pfSettings = pfProvider ? pfProvider.settings : null;
        const creds = (pfSettings && pfSettings.credentials) ? pfSettings.credentials : {};
        const merchantId = creds.merchant_id || '10000100';
        const merchantKey = creds.merchant_key || '46f0cd694581a';
        const baseUrl = (pfSettings && pfSettings.sandbox_mode === false) ? 'https://www.payfast.co.za/eng/process' : 'https://sandbox.payfast.co.za/eng/process';
        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('payfast_return', 'success');
        returnUrl.searchParams.set('order', order.order_number);
        returnUrl.searchParams.set('order_id', order.id);
        const cancelUrl = new URL(window.location.href);
        cancelUrl.searchParams.set('payfast_return', 'cancel');
        cancelUrl.searchParams.set('order_id', order.id);
        const params = new URLSearchParams({
          merchant_id: merchantId, merchant_key: merchantKey,
          return_url: returnUrl.toString(), cancel_url: cancelUrl.toString(),
          name_first: checkoutForm.name.split(' ')[0], name_last: checkoutForm.name.split(' ').slice(1).join(' '),
          email_address: checkoutForm.email, m_payment_id: order.id,
          amount: Number(total).toFixed(2), item_name: 'Order ' + order.order_number
        });
        if (creds.passphrase) params.append('passphrase', creds.passphrase);
        sessionStorage.setItem('pf_pending_cart', JSON.stringify(cart));
        sessionStorage.setItem('pf_pending_customer', JSON.stringify(checkoutForm));
        cart = [];
        saveCart();
        window.location.href = baseUrl + '?' + params.toString();
        return;
      }

      cart = [];
      saveCart();
      document.getElementById('checkout-body').innerHTML = '<div style="text-align:center;padding:40px 0;"><div style="width:60px;height:60px;background:#d1fae5;color:#10b981;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;font-size:30px;">✓</div><h3 style="font-size:24px;font-weight:900;margin-bottom:8px;color:#111827;">Order Confirmed!</h3><p style="color:#6b7280;font-size:14px;margin-bottom:24px;">Your order number is <strong>' + order.order_number + '</strong></p><button class="checkout-btn" onclick="closeCheckout()" style="background:#111827;color:#fff;">Continue Shopping</button></div>';
    } catch(err) {
      console.error(err);
      document.getElementById('checkout-error').textContent = 'Checkout failed. Please try again.';
      document.getElementById('checkout-error').style.display = 'block';
      document.getElementById('checkout-submit-btn').style.display = 'block';
      document.getElementById('checkout-spinner').style.display = 'none';
    }
  }

  async function initPaymentCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const payfastReturn = urlParams.get('payfast_return');
    const orderNum = urlParams.get('order');
    const orderId = urlParams.get('order_id');

    if (payfastReturn === 'success') {
      if (orderId) {
        try {
          await fetch(SUPABASE_URL + '/rest/v1/store_orders_1772955957776?id=eq.' + orderId, {
            method: 'PATCH',
            headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY, 'Content-Type': 'application/json', 'Prefer': 'return=minimal' },
            body: JSON.stringify({ payment_status: 'successful' })
          });
        } catch(e) { console.error('Failed to update status', e); }
      }
      sessionStorage.removeItem('pf_pending_cart');
      sessionStorage.removeItem('pf_pending_customer');
      window.history.replaceState({}, document.title, window.location.pathname);
      document.getElementById('checkout-modal').classList.add('open');
      document.getElementById('checkout-body').innerHTML = '<div style="text-align:center;padding:40px 0;"><div style="width:60px;height:60px;background:#d1fae5;color:#10b981;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;font-size:30px;">✓</div><h3 style="font-size:24px;font-weight:900;margin-bottom:8px;color:#111827;">Order Confirmed!</h3><p style="color:#6b7280;font-size:14px;margin-bottom:24px;">Your order number is <strong>' + orderNum + '</strong></p><button class="checkout-btn" onclick="closeCheckout()" style="background:#111827;color:#fff;">Continue Shopping</button></div>';
    } else if (payfastReturn === 'cancel') {
      if (orderId) {
        try {
          await fetch(SUPABASE_URL + '/rest/v1/store_orders_1772955957776?id=eq.' + orderId, {
            method: 'PATCH',
            headers: { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY, 'Content-Type': 'application/json', 'Prefer': 'return=minimal' },
            body: JSON.stringify({ payment_status: 'failed' })
          });
        } catch(e) { console.error('Failed to update status', e); }
      }
      const pending = sessionStorage.getItem('pf_pending_cart');
      if (pending) { try { cart = JSON.parse(pending); saveCart(); } catch(e){} sessionStorage.removeItem('pf_pending_cart'); }
      sessionStorage.removeItem('pf_pending_customer');
      window.history.replaceState({}, document.title, window.location.pathname);
      toggleCart(true);
      setTimeout(() => alert('Payment was cancelled. Your cart has been restored.'), 500);
    }
  }

  window.updateQuantity = updateQuantity;
  window.removeFromCart = removeFromCart;
  window.selectProvider = selectProvider;
  window.closeCheckout = closeCheckout;
  window.setModalImage = setModalImage;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  `;

  // WhatsApp floating button HTML
  const whatsappButtonHtml = whatsappWidget.enabled && whatsappWidget.number
    ? `<a href="https://wa.me/${whatsappWidget.number.replace(/[^0-9]/g, '')}" class="whatsapp-float" target="_blank" rel="noopener noreferrer" title="Chat with us on WhatsApp">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
        </svg>
      </a>`
    : '';

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${pageTitle}</title>
  <meta name="description" content="${metaDescription}">
  ${faviconUrl ? `<link rel="icon" type="image/png" href="${faviconUrl}"><link rel="apple-touch-icon" href="${faviconUrl}">` : ''}
  <meta property="og:type" content="website">
  <meta property="og:title" content="${pageTitle}">
  <meta property="og:description" content="${metaDescription}">
  ${shareImageUrl ? `<meta property="og:image" content="${shareImageUrl}">` : ''}
  <meta name="twitter:card" content="summary_large_image">
  <meta name="twitter:title" content="${pageTitle}">
  <meta name="twitter:description" content="${metaDescription}">
  ${shareImageUrl ? `<meta name="twitter:image" content="${shareImageUrl}">` : ''}
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700;900&display=swap" rel="stylesheet">
  <style>
    :root{
      --menu-bg:${menuStyles?.backgroundColor || '#ffffff'};
      --menu-text:${menuStyles?.textColor || '#4b5563'};
      --menu-hover:${menuStyles?.hoverColor || '#2dd4bf'};
      --footer-bg:${footer.backgroundColor};
      --footer-text:${footer.textColor};
      --footer-accent:${footer.accentColor};
      --footer-heading:${footer.headingColor};
    }
    html{scroll-behavior:smooth;}
    body{margin:0;font-family:'Inter',system-ui,-apple-system,sans-serif;background:#ffffff;color:#111827;overflow-x:hidden;-webkit-font-smoothing:antialiased;}
    *{box-sizing:border-box;}
    .page-transition{opacity:1;transition:opacity 0.3s ease-in-out;}
    .page-transition.fade-out{opacity:0;}
    .container{max-width:1240px;margin:0 auto;padding:0 24px;}
    .section-container{position:relative;width:100%;}
    .section-overlay{position:absolute;inset:0;z-index:1;}
    .relative{position:relative;}
    .z-10{z-index:10;}
    .row{display:flex;flex-wrap:wrap;gap:32px;align-items:center;justify-content:center;}
    .col{flex:1 1 300px;display:flex;flex-direction:column;gap:20px;justify-content:center;}
    .widget-heading{margin:0;font-family:'Inter',sans-serif;line-height:1.2;letter-spacing:-0.02em;width:100%;}
    .widget-text{margin:0;line-height:1.6;width:100%;}
    .widget-text p{margin:0 0 1em 0;}
    .widget-text p:last-child{margin:0;}
    .widget-button-wrapper{display:flex;justify-content:center;width:100%;}
    .widget-button{padding:16px 40px;font-weight:900;text-decoration:none;display:inline-block;transition:all 0.3s cubic-bezier(0.4,0,0.2,1);box-shadow:0 4px 6px -1px rgba(0,0,0,0.1);}
    .widget-button:hover{transform:translateY(-2px);box-shadow:0 10px 15px -3px rgba(0,0,0,0.1);}
    .widget-image{width:100%;height:auto;display:block;}
    .header{display:flex;justify-content:space-between;align-items:center;padding:${headerPadding?.top || 24}px 40px ${headerPadding?.bottom || 24}px;background-color:var(--menu-bg);position:sticky;top:0;z-index:50;border-bottom:1px solid rgba(0,0,0,0.05);transition:all 0.3s ease;}
    .logo{font-size:24px;font-weight:900;color:var(--menu-text);text-decoration:none;letter-spacing:-0.05em;display:flex;align-items:center;}
    .logo img{max-height:40px;}
    .nav-wrapper{display:flex;align-items:center;gap:32px;}
    .nav-links{display:flex;gap:32px;align-items:center;}
    .nav-links a{color:var(--menu-text);text-decoration:none;font-weight:700;font-size:14px;transition:color 0.2s;}
    .nav-links a:hover{color:var(--menu-hover);}
    .mobile-menu-btn{display:none;background:none;border:none;color:var(--menu-text);cursor:pointer;padding:8px;}
    .cart-btn{position:relative;background:none;border:none;cursor:pointer;color:var(--menu-text);padding:8px;transition:color 0.2s;display:flex;align-items:center;}
    .cart-btn:hover{color:var(--menu-hover);}
    .cart-badge{position:absolute;top:0;right:0;background:#2dd4bf;color:white;font-size:10px;font-weight:900;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;transform:translate(25%,-25%);}

    /* PRODUCTS WIDGET */
    .products-widget-wrapper{padding:48px 0;}
    .products-full-width{width:100%;padding-left:24px;padding-right:24px;}
    .products-contained{max-width:1240px;margin:0 auto;padding-left:24px;padding-right:24px;}
    ${dynamicGridCSS}
    .empty-products{text-align:center;padding:40px;color:#6b7280;font-weight:bold;}
    .product-card{background:#fff;border:1px solid #f3f4f6;border-radius:16px;overflow:hidden;box-shadow:0 4px 6px -1px rgba(0,0,0,0.05);display:flex;flex-direction:column;transition:all 0.3s ease;cursor:pointer;}
    .product-card:hover{transform:translateY(-4px);box-shadow:0 12px 24px -8px rgba(0,0,0,0.1);border-color:#e5e7eb;}
    .product-image-wrapper{position:relative;width:100%;padding-top:100%;background:#f9fafb;overflow:hidden;}
    .product-image{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:transform 0.5s ease;}
    .product-image-placeholder{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#f9fafb;}
    .product-card:hover .product-image{transform:scale(1.05);}
    .sale-badge{position:absolute;top:16px;left:16px;background:#ef4444;color:#fff;font-size:12px;font-weight:900;text-transform:uppercase;padding:6px 12px;border-radius:20px;box-shadow:0 2px 4px rgba(239,68,68,0.3);z-index:10;}
    .custom-badge{position:absolute;top:16px;left:16px;font-size:12px;font-weight:900;text-transform:uppercase;padding:6px 12px;border-radius:20px;z-index:10;box-shadow:0 2px 4px rgba(0,0,0,0.15);}
    .product-info{padding:20px;display:flex;flex-direction:column;flex:1;gap:8px;}
    .product-category{font-size:11px;font-weight:900;text-transform:uppercase;color:#2dd4bf;letter-spacing:0.05em;}
    .product-title{margin:0;font-size:16px;font-weight:800;color:#111827;line-height:1.3;}
    .product-pricing{display:flex;align-items:baseline;gap:8px;}
    .product-price{font-weight:900;font-size:22px;color:#111827;}
    .product-compare-price{font-size:14px;color:#9ca3af;text-decoration:line-through;font-weight:500;}
    .product-stock-row{display:flex;align-items:center;gap:6px;margin-top:2px;}
    .product-stock-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;}
    .product-stock-label{font-size:12px;font-weight:600;}
    .add-to-cart-btn{width:100%;background:#111827;color:#fff;padding:14px;border-radius:12px;border:none;font-weight:900;font-size:14px;cursor:pointer;transition:all 0.2s;display:flex;align-items:center;justify-content:center;gap:8px;margin-top:auto;}
    .add-to-cart-btn:hover:not(:disabled){background:#2dd4bf;transform:translateY(-2px);}
    .add-to-cart-btn:disabled{background:#9ca3af;cursor:not-allowed;}

    /* PRODUCT MODAL */
    .product-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.65);backdrop-filter:blur(6px);z-index:1500;display:none;align-items:center;justify-content:center;padding:20px;overflow-y:auto;}
    .product-modal-overlay.open{display:flex;}
    .product-modal-box{background:#fff;width:100%;max-width:960px;border-radius:24px;box-shadow:0 25px 60px -12px rgba(0,0,0,0.35);overflow:hidden;display:grid;grid-template-columns:1fr 1fr;max-height:90vh;}
    .product-modal-image-side{position:relative;background:#f3f4f6;display:flex;flex-direction:column;overflow:hidden;min-height:400px;}
    .product-modal-main-img-wrap{position:relative;width:100%;padding-top:100%;flex-shrink:0;}
    .product-modal-main-img-wrap img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:16px;}
    .modal-nav-btn{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.92);border:none;width:36px;height:36px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;box-shadow:0 2px 8px rgba(0,0,0,0.15);transition:all 0.2s;}
    .modal-nav-btn:hover{background:#fff;transform:translateY(-50%) scale(1.06);}
    .modal-nav-btn.prev{left:12px;}
    .modal-nav-btn.next{right:12px;}
    .modal-thumbnails{display:flex;gap:8px;padding:12px;overflow-x:auto;background:#f9fafb;border-top:1px solid #e5e7eb;}
    .modal-thumbnails::-webkit-scrollbar{height:4px;}
    .modal-thumbnails::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:4px;}
    .modal-thumb{width:52px;height:52px;border-radius:8px;overflow:hidden;border:2px solid transparent;cursor:pointer;flex-shrink:0;transition:all 0.2s;background:none;padding:0;}
    .modal-thumb img{width:100%;height:100%;object-fit:cover;}
    .modal-thumb.active{border-color:#14b8a6;transform:scale(1.06);opacity:1;}
    .modal-thumb:not(.active){opacity:0.55;}
    .modal-thumb:hover:not(.active){border-color:#d1d5db;}
    .product-modal-content{padding:40px;display:flex;flex-direction:column;overflow-y:auto;-webkit-overflow-scrolling:touch;}
    .modal-close-btn{position:absolute;top:16px;right:16px;background:rgba(255,255,255,0.95);border:none;width:36px;height:36px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.12);transition:all 0.2s;z-index:20;}
    .modal-close-btn:hover{background:#fff;transform:scale(1.1);}
    .modal-product-category{font-size:10px;font-weight:900;text-transform:uppercase;color:#14b8a6;margin-bottom:12px;letter-spacing:0.1em;display:block;}
    .modal-product-title{font-size:28px;font-weight:900;color:#111827;margin:0 0 16px 0;line-height:1.2;}
    .modal-product-pricing{display:flex;align-items:baseline;gap:12px;margin-bottom:16px;}
    .modal-product-price{font-size:32px;font-weight:900;color:#111827;}
    .modal-product-compare-price{font-size:18px;color:#9ca3af;text-decoration:line-through;font-weight:500;}
    .modal-stock-row{display:flex;align-items:center;gap:8px;margin-bottom:20px;padding:8px 12px;background:#f9fafb;border-radius:10px;}
    .modal-stock-dot{width:10px;height:10px;border-radius:50%;flex-shrink:0;}
    .modal-stock-label{font-size:13px;font-weight:700;}
    .modal-description-label{font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:0.1em;color:#6b7280;margin-bottom:8px;}
    .modal-product-description{color:#4b5563;line-height:1.7;font-size:14px;margin-bottom:20px;overflow-y:auto;-webkit-overflow-scrolling:touch;}
    .modal-product-description p{margin:0 0 0.75em 0;}
    .modal-product-description p:last-child{margin:0;}
    .modal-footer{margin-top:auto;padding-top:20px;border-top:1px solid #f3f4f6;}
    .modal-add-to-cart-btn{width:100%;background:#111827;color:#fff;padding:16px 24px;border-radius:12px;border:none;font-weight:900;font-size:16px;cursor:pointer;transition:all 0.3s;display:flex;align-items:center;justify-center;gap:10px;box-shadow:0 4px 6px -1px rgba(0,0,0,0.1);}
    .modal-add-to-cart-btn:hover:not(:disabled){background:#000000;transform:translateY(-2px);box-shadow:0 10px 15px -3px rgba(0,0,0,0.2);}
    .modal-add-to-cart-btn.disabled,.modal-add-to-cart-btn:disabled{background:#d1d5db;color:#9ca3af;cursor:not-allowed;transform:none;box-shadow:none;}

    /* REVIEWS WIDGET */
    .reviews-widget-wrapper{width:100%;display:flex;flex-direction:column;padding:48px 0;}
    .reviews-full-width{width:100%;padding-left:24px;padding-right:24px;}
    .reviews-contained{max-width:1240px;margin:0 auto;padding-left:24px;padding-right:24px;}
    .reviews-summary{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-bottom:32px;}
    .reviews-summary-stars{display:flex;align-items:center;gap:4px;margin-bottom:8px;}
    .reviews-summary-score{font-size:20px;font-weight:700;font-family:'Inter',sans-serif;}
    .reviews-summary-count{font-size:14px;opacity:0.7;margin-top:4px;font-family:'Inter',sans-serif;}
    .reviews-grid{display:grid;gap:24px;width:100%;}
    .reviews-grid-1{grid-template-columns:1fr;}
    .reviews-grid-2{grid-template-columns:1fr;}
    @media(min-width:768px){.reviews-grid-2{grid-template-columns:repeat(2,1fr);}}
    .reviews-grid-3{grid-template-columns:1fr;}
    @media(min-width:768px){.reviews-grid-3{grid-template-columns:repeat(3,1fr);}}
    .review-card{padding:24px;box-shadow:0 1px 2px 0 rgba(0,0,0,0.05);border:1px solid rgba(0,0,0,0.05);display:flex;flex-direction:column;}
    .review-stars{display:flex;align-items:center;gap:4px;margin-bottom:16px;}
    .review-content{margin:0 0 24px 0;opacity:0.9;line-height:1.6;font-size:14px;font-family:'Inter',sans-serif;}
    .review-author{display:flex;align-items:center;gap:12px;margin-top:auto;}
    .review-avatar{width:40px;height:40px;border-radius:50%;object-fit:cover;}
    .review-author-info{display:flex;flex-direction:column;}
    .review-author-name{font-weight:700;font-size:14px;font-family:'Inter',sans-serif;}
    .review-author-role{font-size:12px;opacity:0.7;font-family:'Inter',sans-serif;}

    /* WHATSAPP */
    .whatsapp-float{position:fixed;bottom:24px;right:24px;width:56px;height:56px;background:#25D366;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 16px rgba(37,211,102,0.4);z-index:1000;transition:all 0.3s ease;text-decoration:none;}
    .whatsapp-float:hover{background:#20BA5A;transform:scale(1.1);box-shadow:0 12px 24px rgba(37,211,102,0.5);}
    .whatsapp-float svg{color:#ffffff;}

    /* FOOTER */
    .footer{background-color:var(--footer-bg);color:var(--footer-text);padding:80px 24px 40px;}
    .footer-content{max-width:1200px;margin:0 auto;}
    .footer-grid{display:grid;grid-template-columns:1fr;gap:40px;margin-bottom:40px;}
    @media(min-width:768px){.footer-grid{grid-template-columns:repeat(3,1fr);}}
    .footer-company h2{color:var(--footer-heading);font-size:24px;font-weight:900;margin:0 0 16px 0;}
    .footer-company p{margin:0;line-height:1.6;font-size:14px;}
    .footer-section h4{color:var(--footer-accent);font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:0.1em;margin:0 0 16px 0;}
    .footer-links{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:10px;}
    .footer-links a{color:var(--footer-text);text-decoration:none;font-size:14px;transition:color 0.2s;}
    .footer-links a:hover{color:var(--footer-accent);}
    .footer-contact p{margin:0 0 16px 0;line-height:1.6;font-size:14px;}
    .footer-contact-btn{padding:10px 20px;border-radius:24px;text-decoration:none;font-size:12px;font-weight:900;text-transform:uppercase;letter-spacing:0.05em;transition:all 0.3s;display:inline-block;box-shadow:0 4px 6px -1px rgba(0,0,0,0.1);}
    .footer-contact-btn:hover{transform:scale(1.05);}
    .footer-bottom{border-top:1px solid rgba(255,255,255,0.08);padding-top:24px;display:flex;flex-direction:column;align-items:center;gap:16px;text-align:center;}
    @media(min-width:640px){.footer-bottom{flex-direction:row;justify-content:space-between;}}
    .footer-bottom p{font-size:13px;margin:0;}
    .footer-bottom-love{display:flex;align-items:center;gap:6px;font-size:13px;}
    .footer-heart{color:var(--footer-accent);font-weight:900;font-size:14px;}

    /* CART & CHECKOUT */
    .cart-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.5);backdrop-filter:blur(4px);z-index:999;opacity:0;pointer-events:none;transition:opacity 0.3s;}
    .cart-overlay.open{opacity:1;pointer-events:auto;}
    .cart-sidebar{position:fixed;top:0;right:-100%;width:420px;max-width:100%;height:100vh;background:#fff;z-index:1000;transition:right 0.3s cubic-bezier(0.4,0,0.2,1);display:flex;flex-direction:column;box-shadow:-10px 0 30px rgba(0,0,0,0.1);}
    .cart-sidebar.open{right:0;}
    .cart-header{padding:24px;border-bottom:1px solid #f3f4f6;display:flex;justify-content:space-between;align-items:center;}
    .cart-title{font-size:20px;font-weight:900;margin:0;color:#111;}
    .close-cart-btn{background:none;border:none;cursor:pointer;color:#6b7280;padding:8px;border-radius:8px;transition:background 0.2s;}
    .close-cart-btn:hover{background:#f3f4f6;color:#111;}
    .cart-items{flex:1;overflow-y:auto;padding:24px;display:flex;flex-direction:column;gap:24px;}
    .cart-empty{text-align:center;color:#9ca3af;font-weight:600;margin-top:40px;}
    .cart-item{display:flex;gap:16px;}
    .cart-item-img{width:80px;height:80px;border-radius:12px;object-fit:cover;background:#f9fafb;border:1px solid #f3f4f6;}
    .cart-item-details{flex:1;display:flex;flex-direction:column;}
    .cart-item-title{font-size:14px;font-weight:700;margin:0 0 4px 0;color:#111;}
    .cart-item-price{font-size:14px;font-weight:900;color:#111;margin-bottom:auto;}
    .cart-item-actions{display:flex;align-items:center;justify-content:space-between;margin-top:8px;}
    .qty-controls{display:flex;align-items:center;border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;}
    .qty-btn{background:#f9fafb;border:none;padding:4px 12px;cursor:pointer;font-weight:bold;color:#4b5563;}
    .qty-btn:hover{background:#e5e7eb;}
    .qty-val{padding:4px 12px;font-size:12px;font-weight:700;border-left:1px solid #e5e7eb;border-right:1px solid #e5e7eb;}
    .remove-btn{background:none;border:none;color:#ef4444;font-size:12px;font-weight:700;cursor:pointer;}
    .cart-footer{padding:24px;border-top:1px solid #f3f4f6;background:#f9fafb;}
    .cart-total-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;}
    .cart-total-label{font-size:16px;font-weight:600;color:#4b5563;}
    .cart-total-value{font-size:24px;font-weight:900;color:#111;}
    .checkout-btn{width:100%;background:#111827;color:#fff;padding:18px;border-radius:12px;border:none;font-weight:900;font-size:16px;cursor:pointer;transition:all 0.3s;}
    .checkout-btn:hover{background:#000000;transform:translateY(-2px);box-shadow:0 10px 15px -3px rgba(0,0,0,0.2);}
    .checkout-btn:disabled{opacity:0.5;cursor:not-allowed;}

    /* CHECKOUT MODAL — REBUILT TO MATCH CANVAS WITH BLACK BUTTONS & PHONE FIELD */
    .checkout-modal{position:fixed;inset:0;background:rgba(0,0,0,0.6);backdrop-filter:blur(4px);z-index:2000;display:none;align-items:center;justify-content:center;padding:20px;}
    .checkout-modal.open{display:flex;}
    .checkout-box{background:#fff;width:100%;max-width:600px;border-radius:24px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);overflow:hidden;display:flex;flex-direction:column;max-height:90vh;}
    .checkout-header{padding:24px;border-bottom:1px solid #f3f4f6;display:flex;justify-content:space-between;align-items:center;}
    .checkout-body{padding:24px;overflow-y:auto;flex:1;}
    .checkout-input{width:100%;padding:14px;border:1px solid #e5e7eb;border-radius:8px;margin-bottom:16px;font-family:'Inter',sans-serif;outline:none;font-size:14px;}
    .checkout-input:focus{border-color:#111827;}
    .checkout-label{display:block;font-size:11px;font-weight:900;text-transform:uppercase;letter-spacing:0.05em;color:#6b7280;margin-bottom:8px;}
    .checkout-section-title{font-size:16px;font-weight:900;color:#111827;margin:24px 0 16px 0;display:flex;align-items:center;gap:8px;}
    .checkout-section-title:first-child{margin-top:0;}
    .checkout-row{display:flex;gap:12px;margin-bottom:16px;}
    .checkout-row > div{flex:1;}
    #checkout-error{color:#ef4444;font-size:14px;font-weight:600;margin-bottom:16px;display:none;padding:12px;background:#fef2f2;border-radius:8px;border:1px solid #fecaca;}
    .loading-spinner{display:none;margin:0 auto;border:3px solid #f3f4f6;border-top:3px solid #111827;border-radius:50%;width:24px;height:24px;animation:spin 1s linear infinite;}
    @keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}

    .payment-method-card{width:100%;display:flex;align-items:center;gap:12px;padding:14px;border:2px solid #e5e7eb;border-radius:12px;background:#fff;cursor:pointer;transition:all 0.2s;margin-bottom:12px;}
    .payment-method-card:hover{border-color:#d1d5db;background:#f9fafb;}
    .payment-method-card.selected{border-color:#111827;background:#f9fafb;}
    .payment-icon{width:56px;height:40px;background:#fff;border-radius:8px;display:flex;align-items:center;justify-content:center;overflow:hidden;border:1px solid #f3f4f6;flex-shrink:0;}
    .payment-icon img{width:100%;height:100%;object-fit:contain;}
    .payment-info{flex:1;min-width:0;}
    .payment-name{font-weight:900;font-size:14px;color:#111827;}
    .payment-desc{font-size:12px;color:#6b7280;margin-top:2px;}
    .payment-radio{width:20px;height:20px;border-radius:50%;border:2px solid #d1d5db;flex-shrink:0;display:flex;align-items:center;justify-content:center;}
    .payment-method-card.selected .payment-radio{border-color:#111827;background:#111827;}
    .payment-radio-dot{width:8px;height:8px;background:#fff;border-radius:50%;}
    
    .checkout-footer{padding:20px 24px;border-top:1px solid #f3f4f6;display:flex;align-items:center;justify-content:space-between;gap:12px;}
    #checkout-back-btn{padding:12px 20px;background:#f3f4f6;color:#6b7280;border:none;border-radius:8px;font-weight:900;font-size:14px;cursor:pointer;transition:all 0.2s;}
    #checkout-back-btn:hover{background:#e5e7eb;color:#111827;}
    #checkout-submit-btn{padding:16px 32px;background:#111827;color:#fff;border:none;border-radius:8px;font-weight:900;font-size:16px;cursor:pointer;transition:all 0.3s;flex:1;}
    #checkout-submit-btn:hover:not(:disabled){background:#000000;transform:translateY(-2px);box-shadow:0 8px 12px -4px rgba(0,0,0,0.3);}
    #checkout-submit-btn:disabled{opacity:0.5;cursor:not-allowed;}

    #mobile-nav{display:none;padding:20px;background:var(--menu-bg);border-top:1px solid rgba(0,0,0,0.05);}
    #mobile-nav.open{display:flex;flex-direction:column;gap:16px;}
    #mobile-nav a{color:var(--menu-text);text-decoration:none;font-weight:700;font-size:16px;}
    .contact-form-wrapper{max-width:600px;margin:0 auto;padding:40px;box-shadow:0 10px 25px rgba(0,0,0,0.05);}
    .contact-form{display:flex;flex-direction:column;gap:20px;}
    .form-row{display:flex;gap:20px;}
    .contact-form input,.contact-form textarea{width:100%;padding:16px;border:1px solid #e5e7eb;outline:none;font-family:'Inter',sans-serif;transition:border-color 0.2s;}
    .contact-form input:focus,.contact-form textarea:focus{border-color:#2dd4bf;}
    .form-submit-btn{padding:18px;border:none;font-weight:900;font-size:16px;cursor:pointer;transition:all 0.3s;}
    .form-submit-btn:hover{transform:translateY(-2px);box-shadow:0 10px 15px -3px rgba(0,0,0,0.1);}

    @media(max-width:768px){
      .nav-links{display:none;}
      .mobile-menu-btn{display:block;}
      .header{padding:16px 24px;}
      .form-row{flex-direction:column;gap:0;}
      .product-modal-box{grid-template-columns:1fr;max-height:none;overflow-y:auto;}
      .product-modal-image-side{min-height:280px;}
      .product-modal-main-img-wrap{min-height:280px;}
      .product-modal-content{padding:24px;}
      .modal-product-title{font-size:22px;}
      .modal-product-price{font-size:26px;}
      .checkout-row{flex-direction:column;gap:0;}
    }
  </style>

  <script>
    window.__STORE_PRODUCTS__ = ${JSON.stringify(productRegistry)};
    window.__SUPABASE_URL__ = '${SUPABASE_URL}';
    window.__SUPABASE_KEY__ = '${SUPABASE_ANON_KEY}';
    window.__PROJECT_ID__ = '${projectId || ''}';
  </script>
</head>
<body>
  <header class="header">
    <a href="/" class="logo">
      ${logoData?.type === 'image' && logoData.url
        ? `<img src="${logoData.url}" alt="Logo" />`
        : logoData?.content || 'BRAND LOGO'}
    </a>
    <div class="nav-wrapper">
      <nav class="nav-links">
        ${menuItems?.map(item => `<a href="${item.link || '#'}" class="nav-link">${item.label}</a>`).join('\n') || ''}
      </nav>
      <button class="cart-btn" id="cart-toggle-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
        <span class="cart-badge" id="cart-badge" style="display:none;">0</span>
      </button>
      <button class="mobile-menu-btn" id="mobile-menu-toggle">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
      </button>
    </div>
  </header>

  <div id="mobile-nav">
    ${menuItems?.map(item => `<a href="${item.link || '#'}" class="nav-link">${item.label}</a>`).join('\n') || ''}
  </div>

  <main id="main-content" class="page-transition" style="padding-top:${canvasPadding?.top || 0}px;padding-bottom:${canvasPadding?.bottom || 0}px;min-height:80vh;">
    ${bodyHtml}
  </main>

  <footer class="footer">
    <div class="footer-content">
      <div class="footer-grid">
        <div class="footer-company">
          <h2>${footer.companyName}</h2>
          <p>${footer.tagline}</p>
        </div>
        <div class="footer-section">
          <h4>${footer.quickLinksTitle}</h4>
          <ul class="footer-links">
            ${footer.links.map(link => `<li><a href="${link.href}">${link.label}</a></li>`).join('\n')}
          </ul>
        </div>
        <div class="footer-section footer-contact">
          <h4>${footer.contactTitle}</h4>
          <p>${footer.contactDescription}</p>
          <a href="#contact" class="footer-contact-btn" style="background-color:${footer.contactButtonBg};color:${footer.contactButtonTextColor};">
            ${footer.contactButtonText}
          </a>
        </div>
      </div>
      <div class="footer-bottom">
        <p>${footer.copyright}</p>
        <div class="footer-bottom-love">
          <span>${footer.footerBottomText}</span>
          <span class="footer-heart">❤</span>
        </div>
      </div>
    </div>
  </footer>

  ${whatsappButtonHtml}

  <div class="cart-overlay" id="cart-overlay"></div>
  <div class="cart-sidebar" id="cart-sidebar">
    <div class="cart-header">
      <h2 class="cart-title">Your Cart</h2>
      <button class="close-cart-btn" id="close-cart-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="cart-items" id="cart-items"></div>
    <div class="cart-footer" id="cart-footer" style="display:none;">
      <div class="cart-total-row">
        <span class="cart-total-label">Subtotal</span>
        <span class="cart-total-value" id="cart-total">R0.00</span>
      </div>
      <button class="checkout-btn" id="checkout-btn-open">Proceed to Checkout</button>
    </div>
  </div>

  <!-- CHECKOUT MODAL — REBUILT TO MATCH CANVAS WITH BLACK BUTTONS & PHONE FIELD -->
  <div class="checkout-modal" id="checkout-modal">
    <div class="checkout-box">
      <div class="checkout-header">
        <h2 class="cart-title">Secure Checkout</h2>
        <button class="close-cart-btn" id="close-checkout-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
      <div class="checkout-body" id="checkout-body">
        <form id="checkout-form">
          <div id="checkout-error"></div>

          <!-- STEP 1: Customer Information & Billing -->
          <div id="checkout-step-1">
            <h3 class="checkout-section-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              Customer Information
            </h3>
            <label class="checkout-label">Full Name</label>
            <input type="text" class="checkout-input" data-field="name" placeholder="Jane Doe" required />
            
            <div class="checkout-row">
              <div>
                <label class="checkout-label">Email Address</label>
                <input type="email" class="checkout-input" data-field="email" placeholder="jane@example.com" required />
              </div>
              <div>
                <label class="checkout-label">Phone Number</label>
                <input type="tel" class="checkout-input" data-field="phone" placeholder="+27 12 345 6789" required />
              </div>
            </div>

            <h3 class="checkout-section-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              Billing Address
            </h3>
            <label class="checkout-label">Street Address</label>
            <input type="text" class="checkout-input" data-field="address" placeholder="123 Main Street" required />
            
            <div class="checkout-row">
              <div>
                <label class="checkout-label">City</label>
                <input type="text" class="checkout-input" data-field="city" placeholder="City" required />
              </div>
              <div>
                <label class="checkout-label">Zip / Postal Code</label>
                <input type="text" class="checkout-input" data-field="zipCode" placeholder="Zip Code" required />
              </div>
            </div>

            <div class="checkout-row">
              <div>
                <label class="checkout-label">Country</label>
                <select class="checkout-input" data-field="country">
                  <option value="South Africa">South Africa</option>
                  <option value="United States">United States</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Australia">Australia</option>
                  <option value="Namibia">Namibia</option>
                </select>
              </div>
              <div>
                <label class="checkout-label">State / Province</label>
                <input type="text" class="checkout-input" data-field="state" placeholder="State / Province" />
              </div>
            </div>

            <label class="checkout-label">Company Name (Optional)</label>
            <input type="text" class="checkout-input" data-field="company" placeholder="Company Name" />
          </div>

          <!-- STEP 2: Payment Method -->
          <div id="checkout-step-2" style="display:none;">
            <h3 class="checkout-section-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
              Payment Method
            </h3>
            <div id="payment-providers-container"></div>
          </div>
        </form>
      </div>
      <div class="checkout-footer">
        <button type="button" id="checkout-back-btn" style="display:none;" onclick="currentCheckoutStep=1;renderCheckoutStep();">Back to Details</button>
        <button type="submit" form="checkout-form" id="checkout-submit-btn">Continue to Payment</button>
        <div class="loading-spinner" id="checkout-spinner"></div>
      </div>
    </div>
  </div>

  <!-- PRODUCT MODAL -->
  <div class="product-modal-overlay" id="product-modal">
    <div class="product-modal-box">
      <div class="product-modal-image-side">
        <div class="product-modal-main-img-wrap">
          <img id="modal-product-image" src="" alt="Product" />
          <button class="modal-nav-btn prev" id="modal-prev-btn" style="display:none;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>
          <button class="modal-nav-btn next" id="modal-next-btn" style="display:none;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
          <button class="modal-close-btn" id="modal-close-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="modal-thumbnails" id="modal-thumbnails" style="display:none;"></div>
      </div>
      <div class="product-modal-content">
        <div id="modal-product-category" class="modal-product-category"></div>
        <h2 id="modal-product-title" class="modal-product-title"></h2>
        <div class="modal-product-pricing">
          <span id="modal-product-price" class="modal-product-price"></span>
          <span id="modal-product-compare-price" class="modal-product-compare-price" style="display:none;"></span>
        </div>
        <div class="modal-stock-row">
          <span class="modal-stock-dot" id="modal-stock-dot"></span>
          <span class="modal-stock-label" id="modal-stock-label"></span>
        </div>
        <div class="modal-description-label">Description</div>
        <div id="modal-product-description" class="modal-product-description"></div>
        <div class="modal-footer">
          <button id="modal-add-to-cart" class="modal-add-to-cart-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
            <span>Add to Cart</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <script src="data:text/javascript;base64,${toBase64(storeScript)}"></script>
</body>
</html>`;
}